const pix = require('../pix');

const dictOperationReason = {
  userRequested: 0,
  accountClosure: 1,
  branchTransfer: 2,
  fraud: 4,
  defaultOperation: 5,
  reconciliation: 6,
  convertToJDPI(bcbReason) {
    switch (bcbReason) {
      case pix.bcb.dictOperationReason.USER_REQUESTED:
        return this.userRequested;
      case pix.bcb.dictOperationReason.ACCOUNT_CLOSURE:
        return this.accountClosure;
      case pix.bcb.dictOperationReason.BRANCH_TRANSFER:
        return this.branchTransfer;
      case pix.bcb.dictOperationReason.FRAUD:
        return this.fraud;
      case pix.bcb.dictOperationReason.DEFAULT_OPERATION:
        return this.defaultOperation;
      case pix.bcb.dictOperationReason.RECONCILIATION:
        return this.reconciliation;
      default:
        throw new Error('Invalid BCB DICT operation reason to convert to JDPI');
    }
  }
};

module.exports = dictOperationReason;
